export const nonstandardMap = {
  /* 
    tabArr: [
      { tabName: '已上架商品' }, 
      { tabName: '已下架商品' },
      { tabName: '审核中' },
      { tabName: '审核通过' },
      { tabName: '审核拒绝' },
    ],
  */
  data() {
    return {
      tableLabelAll: [
        {
          label: '图片',
          align: 'center',
          width: '60',
          slot: 'img',
          fixed: 'left',
          hidden: ['1', '2'],
        },
        {
          label: '商品名称',
          align: 'center',
          minWidth: '220',
          slot: 'skuName',
          fixed: 'left',
        },
        {
          label: '商品编号',
          param: 'skuCode',
          align: 'center',
          minWidth: '200',
        },
        {
          label: '所属分类',
          param: 'categoryName',
          align: 'center',
          minWidth: '220',
          hidden: ['1'],
        },
        {
          label: '商品来源',
          align: 'center',
          minWidth: '220',
          slot: 'systemSign',
          hidden: ['1', '2'],
        },
        {
          label: '品牌',
          param: 'brandName',
          align: 'center',
          minWidth: '200',
          hidden: [0, 1, '1', '2'],
        },
        {
          label: '进出口推送状态',
          align: 'center',
          minWidth: '160',
          slot: 'pushStatus',
          hidden: [2, 3, 4, '1', '2'],
        },
        {
          label: '库存',
          align: 'center',
          minWidth: '120',
          slot: 'skuStock',
          hidden: [2, 3, 4, '1', '2'],
        },
        {
          label: '起订量',
          align: 'center',
          minWidth: '120',
          slot: 'minOrderQuantity',
          hidden: [2, 3, 4, '1', '2'],
        },
        {
          label: '发货周期(天)',
          align: 'center',
          minWidth: '120',
          slot: 'deliverTime',
          hidden: [2, 3, 4],
        },
        {
          label: '计量单位',
          param: 'unitValue',
          align: 'center',
          minWidth: '120',
          hidden: ['1', '2'],
        },
        {
          label: '市场价(元)',
          param: 'price',
          align: 'center',
          minWidth: '120',
          slot: 'price',
          hidden: ['1', '2'],
        },
        {
          label: '税率(%)',
          align: 'center',
          minWidth: '120',
          slot: 'taxRateValue',
          hidden: ['1', '2'],
        },
        {
          label: '审核拒绝',
          align: 'center',
          minWidth: '120',
          slot: 'approvalOpinion',
          hidden: [0, 1, 2, 3],
        },
        {
          label: '提交时间',
          param: 'updateTime',
          align: 'center',
          minWidth: '120',
          hidden: [0, 1, 3, 4],
        },
        {
          label: '交货期',
          align: 'center',
          minWidth: '120',
          slot: 'deliveryType',
          hidden: [2, 3, 4, '1', '2'],
        },
        {
          label: 'salesScopeHeader', // 销售范围
          align: 'center',
          header: true,
          slot: 'salesScope',
          width: '150px',
          hidden: [2, 3, 4, '1', '2'],
        },
        {
          label: 'isConfirmHeader', // 订单是否确认
          align: 'center',
          header: true,
          slot: 'isConfirm',
          width: '150px',
          hidden: [2, 3, 4, '1', '2'],
        },
        {
          label: '下架原因',
          align: 'center',
          minWidth: '120',
          slot: 'denialReason',
          hidden: [0, 2, 3, 4, '1', '2'],
        },
        {
          label: '审核时间',
          param: 'updateTime',
          align: 'center',
          minWidth: '120',
          hidden: [1, 2],
        },
        /* {
          label: '店铺显示顺序',
          align: 'center',
          minWidth: '180',
          slot: 'sortNum',
          hidden: [0, 1, 2, 3, 4, '1', '2'],
        }, */
        {
          label: 'operateHeader', // 操作
          align: 'center',
          header: true,
          slot: 'operate',
          width: '150px',
          hidden: [3],
          fixed: 'right',
        },
      ],
      fieldListAll: [
        {
          label: '商品名称',
          type: 'input',
          value: 'skuName',
        },
        {
          label: '商品来源',
          type: 'select',
          value: 'systemSign',
          list: 'systemSignList',
          align: 'center',
          hidden: ['1', '2'],
        },
        { label: '商品编号', type: 'input', value: 'skuCode' },

        {
          label: '进出口推送状态',
          type: 'select',
          value: 'pushStatus',
          align: 'center',
          list: 'pushStatusList',
          hidden: [1, 2, 3, 4, '1', '2'],
        },
        {
          label: '销售范围',
          type: 'select',
          value: 'salesScope',
          list: 'salesScopeList',
          hidden: ['1', '2'],
        },
        {
          label: '所属分类',
          type: 'input',
          value: 'categoryName',
        },
        {
          label: '品牌名称',
          type: 'input',
          value: 'brandName',
          hidden: ['1', '2'],
        },
        {
          label: '可售区域',
          type: 'select',
          value: 'salesScopeId',
          list: 'salesScopeIdList',
          hidden: ['1', '2'],
        },
        /* {
          label: '供应商',
          type: 'select',
          value: 'supplierCompanyId',
          list: 'shieldCompanyNameList',
          filterable: true,
          remote: true,
          reserveKeyword: true,
          loading: this.selectLoading,
          clearable: true,
          companyName: true,
          remoteMethod: this.getShieldCompanyNames,
        }, */
        /* {
          label: '商品类型',
          type: 'select',
          value: 'productType',
          list: 'productTypeList',
        }, */
        {
          label: '审核时间',
          type: 'date',
          value: 'auditTime',
          dateType: 'datetimerange',
          valueFormat: 'yyyy-MM-dd HH:mm:ss',
          defaultTime: ['00:00:00', '23:59:59'],
          placeholder: '审核时间',
          hidden: [2, '2'],
        },
        {
          label: '提交时间',
          type: 'date',
          value: 'updateTime',
          dateType: 'datetimerange',
          valueFormat: 'yyyy-MM-dd HH:mm:ss',
          defaultTime: ['00:00:00', '23:59:59'],
          placeholder: '提交时间',
          hidden: [0, 1, 3, 4],
        },
        {
          label: '商品类型',
          type: 'select',
          value: 'productType',
          list: 'productTypeList',
          hidden: ['1', '2'],
        },
        /* {
          label: '店铺顺序',
          value: 'sortNumScreen',
          type: 'select',
          align: 'center',
          hidden: [1, 2, 3, 4, '1', '2'],
          list: 'sortNumScreenList',
        }, */
      ],
      listTypeInfo: {
        // 进出口推送状态-国际站
        pushStatusList: [
          { id: null, name: '全部' },
          { id: 0, name: '推送中' },
          { id: 1, name: '已推送' },
          { id: 2, name: '推送失败' },
          { id: 3, name: '未推送' },
        ],
        // 商品来源
        systemSignList: [
          { id: null, name: '全部' },
          { id: 1, name: '平台新增' },
          { id: 2, name: '系统集成' },
          { id: 0, name: '保供平台' },
        ],
        // 销售范围
        salesScopeList: [
          { name: '全部', id: 0 },
          {
            name: '全平台',
            id: 1,
          },
          {
            name: '协议客户',
            id: 2,
          },
        ],
        // 可售区域
        salesScopeIdList: [],
        // 商品类型
        productTypeList: [
          { id: 0, name: '普通商品' },
          { id: 1, name: '品牌商城商品' },
        ],
        // 店铺顺序
        sortNumScreenList: [
          { id: '', name: '全部' },
          { id: 1, name: '有店铺顺序' },
        ],
      },
    };
  },
};

export const a = 1;
